import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CancelPhonePendingProcessResponse extends BackendResponse {}
export interface CancelPhonePendingProcessParameters extends NextApiParams {}

export const cancelPhonePendingProcess = withNextApi<
  CancelPhonePendingProcessResponse,
  CancelPhonePendingProcessParameters
>("/cvp/CvpCancelPhonePendingProcess");
